import React from 'react'
import { LocaleProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'
import espanol from 'locales/es-ES'
import english from 'locales/en-US'
import français from 'locales/fr-FR'
import português from 'locales/pt-BR'

const locales = {
  'es-ES': espanol,
  'en-US': english,
  'fr-FR': français,
  'pt-BR': português,
}

@connect(({ settings }) => ({ settings }))
class Localization extends React.Component {
  render() {
    const {
      children,
      settings: { locale },
    } = this.props
    const currentLocale = locales[locale]
    return (
      <LocaleProvider locale={currentLocale.antdData}>
        <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
          {children}
        </IntlProvider>
      </LocaleProvider>
    )
  }
}

export default Localization
